(() => {
  if (window.LifespanFundsRaisedLayout) return;

  const SECTION_SELECTOR = '.funds-raised';

  const buildCounterProbe = (counter) => {
    const targetValue = counter.dataset.target || '';
    const numericTarget = Number.parseInt(targetValue.replace(/[^\d.-]/g, ''), 10);
    const probe = counter.cloneNode(false);
    const prefix = counter.dataset.prefix || '';
    const prefixClass = counter.dataset.prefixClass || '';
    const formattedTarget = Number.isNaN(numericTarget) ? targetValue : numericTarget.toLocaleString('en-US');

    probe.removeAttribute('id');
    probe.removeAttribute('data-funding-counter');
    probe.setAttribute('aria-hidden', 'true');
    probe.style.setProperty('--funds-counter-fit-scale', '1');
    probe.style.minWidth = '0';
    probe.style.opacity = '0';
    probe.style.pointerEvents = 'none';
    probe.style.position = 'absolute';
    probe.style.transform = 'none';
    probe.style.visibility = 'hidden';

    if (prefix) {
      if (prefixClass) {
        const prefixElement = document.createElement('span');
        prefixElement.className = prefixClass;
        prefixElement.textContent = prefix;
        probe.appendChild(prefixElement);
      } else {
        probe.appendChild(document.createTextNode(prefix));
      }
    }

    probe.appendChild(document.createTextNode(formattedTarget));
    return probe;
  };

  const fitCounter = (section) => {
    const pill = section.querySelector('.funds-raised__pill');
    const amount = section.querySelector('.funds-raised__amount');
    const counter = section.querySelector('.funds-raised__value[data-funding-counter]');
    if (!pill || !amount || !counter) return;

    const probe = buildCounterProbe(counter);
    amount.appendChild(probe);
    const targetWidth = probe.getBoundingClientRect().width;
    probe.remove();

    const pillStyles = window.getComputedStyle(pill);
    const horizontalPadding = Number.parseFloat(pillStyles.paddingLeft) + Number.parseFloat(pillStyles.paddingRight);
    const availableWidth = Math.max(0, pill.clientWidth - horizontalPadding - 16);
    const scale = targetWidth > 0 ? Math.min(1, availableWidth / targetWidth) : 1;

    counter.style.setProperty('--funds-counter-fit-scale', scale.toFixed(4));
  };

  const fitLabelCutout = (section) => {
    const outline = section.querySelector('.funds-raised__pill-outline');
    const cutout = outline?.querySelector('[data-funds-label-cutout]');
    const label = section.querySelector('.funds-raised__label');
    if (!outline || !cutout || !label) return;

    const outlineWidth = outline.getBoundingClientRect().width;
    const viewBoxWidth = outline.viewBox.baseVal.width;
    if (!outlineWidth || !viewBoxWidth) return;

    const labelWidthInViewBox = label.getBoundingClientRect().width * (viewBoxWidth / outlineWidth);
    const gapWidth = Math.min(viewBoxWidth - 32, labelWidthInViewBox + 40);

    cutout.setAttribute('x', ((viewBoxWidth - gapWidth) / 2).toFixed(2));
    cutout.setAttribute('width', gapWidth.toFixed(2));
  };

  const updateSection = (section) => {
    fitCounter(section);
    fitLabelCutout(section);
  };

  const initializeSection = (section) => {
    if (section.dataset.fundsRaisedLayoutInitialized === 'true') return;
    section.dataset.fundsRaisedLayoutInitialized = 'true';

    updateSection(section);

    if ('ResizeObserver' in window) {
      const observer = new ResizeObserver(() => updateSection(section));
      const pill = section.querySelector('.funds-raised__pill');
      const label = section.querySelector('.funds-raised__label');

      observer.observe(pill || section);
      if (label) observer.observe(label);
    }

    document.fonts?.ready?.then(() => updateSection(section));
  };

  const initialize = (root = document) => {
    if (root.matches?.(SECTION_SELECTOR)) initializeSection(root);
    root.querySelectorAll?.(SECTION_SELECTOR).forEach(initializeSection);
  };

  window.LifespanFundsRaisedLayout = { initialize };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initialize());
  } else {
    initialize();
  }

  document.addEventListener('shopify:section:load', (event) => initialize(event.target));
})();
